<template>
  <div class="video-list container results">
    <h1>מצאנו לך מספר שיעורים</h1>
    <div class="results-controls">
      <div class="columns video-filter-container">
        <div><h2># תזכורת מה חיפשת</h2></div>

        <div>
          <a
            href="#"
            @click.prevent="
              showModal = true;
              showTextSearch = false;
            "
            class="advanced-search-control"
            ><i class="mdi mdi-pencil"></i> עריכה</a
          >
          <a
            href="#"
            class="advanced-search-control"
            @click.prevent="
              showTextSearch = true;
              showModal = true;
            "
            ><i class="mdi mdi-magnify"></i> חיפוש חופשי</a
          >
        </div>
      </div>
      <div class="columns is-multiline result-tags">
        <results-tag
          v-for="(option, index) in searchTags"
          :key="index"
          :item="option"
        >
        </results-tag>
        <div class="result-tag" v-if="searchTerm !== ''">
          <a href="#" @click.prevent="cleanTextSearch">
            <span class="hash">#</span>
            <i class="mdi mdi-close"></i>
          </a>
          <span>"{{ searchTerm }}"</span>
        </div>
      </div>
      <div class="filter-results-container">
        <sort-results></sort-results>
        <div class="results-count" v-if="filtered > 9">
          מציג {{ showing }} מתוך {{ filtered }} שיעורים שנמצאו
        </div>
        <div class="results-count" v-else>
          <div v-if="filtered > 0">מציג {{ filtered }} שיעורים שנמצאו</div>
        </div>
      </div>
    </div>
    <video-results
      :results="results"
      :showSpinner="showSpinner"
      :showNoResults="showNoResults"
      v-on:filtered-results="setFilteredResults"
    ></video-results>
    <transition name="fade">
      <div :class="modalCls" v-if="showModal">
        <div class="modal-background" @click="showModal = false"></div>
        <div class="modal-wrapper">
          <div class="modal-content">
            <div v-if="showTextSearch" class="search-bar edit-results">
              <div class="columns" style="justify-content: space-between">
                <h3>אשמח למצוא שיעור</h3>
                <div class="has-text-left">
                  <a
                    href="#"
                    @click.prevent="showModal = false"
                    class="close-modal"
                    ><i class="mdi mdi-close"></i
                  ></a>
                </div>
              </div>
              <div class="columns text-search-container">
                <div class="column is-9-desktop advanced-search-input">
                  <input
                    type="text"
                    class="input"
                    v-model="searchTerm"
                    placeholder="כאן ניתן לחפש חופשי..."
                    @keydown.enter="getResults"
                  />
                  <i class="mdi mdi-magnify"></i>
                </div>
                <div class="column is-3-desktop">
                  <a href="#" class="yoga-btn" @click.prevent="getResults"
                    >חיפוש</a
                  >
                </div>
              </div>
            </div>
            <edit-results
              v-else
              v-on:close-edit-results="showModal = false"
            ></edit-results>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import VideoResults from "@/components/VideoResults.vue";
import ResultsTag from "@/components/newSearch/resultsTag.vue";
import EditResults from "@/components/editResults.vue";
import SortResults from "@/components/sortResults.vue";

export default {
  name: `SearchResults`,
  components: {
    VideoResults,
    ResultsTag,
    EditResults,
    SortResults,
  },
  data() {
    return {
      showModal: false,
      showTextSearch: false,
      searchTerm: "",
      showSort: false,
      filtered: 0,
    };
  },
  computed: {
    results() {
      return this.$store.state.sort.results;
    },
    showing() {
      if (this.results.length > 9 * this.$store.state.sort.page) {
        return 9 * this.$store.state.sort.page;
      }

      return this.results.length;
    },
    showSpinner() {
      return this.$store.state.sort.showSpinner;
    },

    showNoResults() {
      return this.$store.state.sort.showNoResults;
    },
    searchTags() {
      let output = [];
      const selected = this.$store.state.sort.selected;
      if (Object.keys(selected).length > 0) {
        const keys = Object.keys(selected);
        const values = Object.values(selected);
        values.forEach((category, index) => {
          if (category.length > 0) {
            category.forEach(option => {
              output.push({ option: option, type: keys[index] });
            });
          }
        });
      }
      return output;
    },
    modalCls() {
      if (this.showModal) {
        return "modal is-active";
      }
      return "modal";
    },
  },
  methods: {
    getResults(e) {
      let obj = {
        term: this.searchTerm,
        metaStyles: this.flattenQuery(
          this.$store.state.sort.selected.metaStyles
        ),
        styles: this.falttenStylesQuery(this.$store.state.sort.selected.styles),
        levels: this.flattenQuery(this.$store.state.sort.selected.levels),
        durations: this.flattenQuery(this.$store.state.sort.selected.durations),
        tempo: this.flattenQuery(this.$store.state.sort.selected.tempo),
        teachers: this.flattenQuery(this.$store.state.sort.selected.teachers),
        focus: this.flattenQuery(this.$store.state.sort.selected.focus),
        bodyPart: this.flattenQuery(this.$store.state.sort.selected.bodyPart),
        equipment: this.flattenQuery(this.$store.state.sort.selected.equipment),
      };
      this.$store.dispatch(`getVideoResults`, obj);
      this.$store.commit("setSearchTerm", this.searchTerm);
      e.currentTarget.blur();
      this.showTextSearch = false;
      this.showModal = false;
    },
    flattenQuery(arr) {
      if (arr) {
        const ids = arr.map(item => item.id);
        return ids.join(",");
      }
      return "";
    },
    falttenStylesQuery(arr) {
      if (arr) {
        const ids = arr.map(item => item.resource.id);
        return ids.join(",");
      }
      return arr;
    },
    cleanTextSearch() {
      this.$store.dispatch("resetSearchTerm");
      this.searchTerm = "";
      this.getResults();
    },
    setFilteredResults(payload) {
      this.filtered = payload.filtered;
    },
  },
  mounted() {
    this.searchTerm = this.$store.state.sort.term;
    this.filtered = this.results.length;
  },
};
</script>

<style lang="scss">
.results {
  h1 {
    padding: 0 15px;
    margin-bottom: 2rem;
    font-weight: bold;
    text-align: center;
  }

  h2 {
    font-size: 1.125rem;
    font-weight: bold;
  }

  .advanced-search-control {
    margin-left: 0;
    margin-right: 1.5rem;
  }

  .modal {
    align-items: flex-start;
  }

  .modal-content {
    min-width: 60%;
    max-width: 1200px;
    min-height: 0.5vh;
    background-color: #ffffff;
    padding: 2rem;
    box-shadow: 7px 4px 10px rgba(0, 0, 0, 0.25);
  }
  .modal-background {
    background-color: rgba(10, 10, 10, 0.6);
  }
  .advanced-search-input {
    position: relative;
    .mdi {
      position: absolute;
      left: 1rem;
      top: 0;
      bottom: 0;
      display: inline-block;
      font-size: 2rem;
      line-height: 4rem;
    }
  }
}

.filter-results-container {
  background: rgba(196, 196, 196, 0.14);
  padding: 1rem;
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: space-between;
  .results-count {
    font-weight: bold;
  }
}

.results,
.home {
  .modal {
    align-items: flex-start;
    padding-top: 10%;
    overflow: auto;
  }
  .modal-wrapper {
    padding-top: 10%;
    width: 100%;
    height: 100vh;
    overflow: scroll;
    position: absolute;
    top: 0;
  }
  .modal-content {
    min-width: 60%;
    min-height: 0.5vh;
    background-color: #ffffff;
    padding: 2rem;
    width: auto;
    box-shadow: 7px 4px 10px rgba(0, 0, 0, 0.25);
    z-index: 100;
  }
  .modal-background {
    background-color: rgba(10, 10, 10, 0.6);
  }
}

.results-controls {
  background-color: #ffffff;
  position: relative;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  .video-filter-container {
    padding: 1rem;
    justify-content: space-between;
  }
}
.result-tags {
  padding: 1rem 1rem;
}
@media screen and (min-width: 768px) {
  .results,
  .home {
    .modal-content {
      overflow: visible;
      width: 100%;
    }
  }
}
</style>
